import axios, { pluckData } from 'src/utilities/http-client'
import { LifecycleState } from 'src/v3/core/types'

type LifecycleTransitionResponse = {
  id: string
  eventID: string
  fromState: LifecycleState
  toState: LifecycleState
  actorID: string | null
  transitionSource: 'manual' | 'cAPCEExpiration'
  createdTime: string
  updatedTime: string
}

let post = (eventId: string, action: string) =>
  axios
    .post<LifecycleTransitionResponse>(
      `/api/pipeline/compliance-event/${eventId}/${action}`,
    )
    .then(pluckData)

export let preArchiveEvent = (eventId: string) => post(eventId, 'pre-archive')
export let reactivateEvent = (eventId: string) => post(eventId, 'reactivate')
export let archiveEvent = (eventId: string) => post(eventId, 'archive')
export let restoreEvent = (eventId: string) => post(eventId, 'restore')
